/**
 * Indicator API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const IndicatorCategoryDto = {
    Quantity: 'QUANTITY',
    Value: 'VALUE',
    Data: 'DATA'
} as const;
export type IndicatorCategoryDto = typeof IndicatorCategoryDto[keyof typeof IndicatorCategoryDto];

